// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ActivatePromoCodeModal_formItem__al01q","buttonWrapper":"ActivatePromoCodeModal_buttonWrapper__aob_8"};